import React, { useState, useEffect } from "react";
import {
  RootContainer,
  Heading,
  NavContainer,
  BackButton,
  SkipButton,
  Input,
  ArrowIconWrapper,
  Logo,
  Title,
  ContentContainer,
  Form,
  ContinueButton,
  ContinueButtonWrapper,
} from '../AuthStack.style';
import { api } from "@api";
import { useNavigate } from "react-router-dom";
import { PUBLIC_ROUTE } from "@router/route.constants";
import { RESET_MODE_SK } from "@constants";
import { useDispatch } from "react-redux";
import { openAlert } from "@redux/app/appSlice";
import { Alert } from "@components";
import { useTranslation } from "react-i18next";

const ForgotPassword = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [disableButton, setDisableButton] = useState(true);
  const [phoneNumber, setPhoneNumber] = useState();

  // Disable Login button when phone number input is empty
  useEffect(() => {
    setDisableButton(!phoneNumber);

  }, [phoneNumber]);
  const onFinish = ({ phone }) => {
    if (!loading) {
      setLoading(true);
      api
        .forgotPassword({ phone })
        .then((response) => {
          setLoading(false);
          showAlert({
            message: response?.message,
            successCallback: () => successCallback(phone),
          });
        })
        .catch((errorMsg) => {
          setLoading(false);
          showAlert({
            message: errorMsg,
            isError: true,
          });
        });
    }
  };

  const successCallback = (phone) => {
    navigate(`/${PUBLIC_ROUTE.OTP_VERIFY}/${RESET_MODE_SK}`, {
      state: { phone },
    });
  };

  const showAlert = (data) => {
    dispatch(openAlert(data));
  };

  const goBack = () => {
    navigate(-1);
  };

  const skip = () => {
    navigate(`/${PUBLIC_ROUTE.HOME}`);
  };

  return (
    <>
      <RootContainer>
        <Heading>
          <NavContainer>
            <ArrowIconWrapper onClick={goBack}>
              <BackButton> {t("auth.back")} </BackButton>
            </ArrowIconWrapper>
            <SkipButton type="secondary" onClick={skip} > {t("common.skip")} </SkipButton>
          </NavContainer>
          <Logo />
        </Heading>

        <ContentContainer>
          <Title> {t("auth.forgotPasswordTitle")} </Title>
          <Form layout="vertical" requiredMark={false} onFinish={onFinish}>
            <Form.Item
              name="phone"
              label={t("auth.forgotPasswordPhone")}
              rules={[
                {
                  required: true,
                  message: "",
                },
                {
                  pattern: /^0(1|9)\d{7,9}$/,
                  message: t("auth.forgotPasswordPhoneValidate"),
                },
              ]}
            >
              <Input
                autoFocus
                type="number"
                size="large"
                placeholder="09*********"
                onChange={(e) => setPhoneNumber(e.target.value)}
              />
            </Form.Item>
            <Form.Item>
              <ContinueButtonWrapper
                disabled={disableButton}
              >
                <ContinueButton
                  type="primary"
                  size="large"
                  htmlType="submit"
                  loading={loading}
                  style={{ width: '100%' }}
                >
                  {t("common.continue")}
                </ContinueButton>
              </ContinueButtonWrapper>
            </Form.Item>
          </Form>
        </ContentContainer>
      </RootContainer>
      <Alert />
    </>
  );
};

export default ForgotPassword;
